var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.rmData
      ? _c("div", { staticClass: "d-md-flex gap-4" }, [
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("h3", { staticClass: "mb-3" }, [
              _vm._v(
                _vm._s(_vm.$t("remoteMonitoring.procedures.form.contacts"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column gap-1" },
              [
                _vm._l(_vm.rmData.channels, function (channel, i) {
                  return _c("MonitoringChannel", {
                    key: channel.id,
                    attrs: { channel: channel, index: i + 1 },
                  })
                }),
                _vm._v(" "),
                !_vm.rmData.channels.length
                  ? _c(
                      "div",
                      { staticClass: "text-muted bg-gray-50 p-2 rounded" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("remoteMonitoring.display.no_channel")
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("h3", { staticClass: "mb-3" }, [
              _vm._v(
                _vm._s(_vm.$t("remoteMonitoring.procedures.form.devices"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column gap-1" },
              [
                _vm._l(_vm.rmData.datis, function (dati, i) {
                  return _c("MonitoringWorker", {
                    key: dati.id,
                    attrs: { worker: dati, index: i + 1 },
                  })
                }),
                _vm._v(" "),
                !_vm.rmData.datis.length
                  ? _c(
                      "div",
                      { staticClass: "text-muted bg-gray-50 p-2 rounded" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("remoteMonitoring.display.no_user")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.rmData
      ? _c(
          "div",
          { staticClass: "text-muted bg-gray-50 p-3 rounded text-md" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("remoteMonitoring.display.no_procedure")) +
                "\n  "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }